var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeltaWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    contentScriptType: "text/ecmascript",
    viewBox: "0 0 1536 2048",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768 256c139.333 0 267.833 34.333 385.5 103s210.833 161.833 279.5 279.5 103 246.167 103 385.5-34.333 267.833-103 385.5-161.833 210.833-279.5 279.5-246.167 103-385.5 103-267.833-34.333-385.5-103-210.833-161.833-279.5-279.5S0 1163.333 0 1024s34.333-267.833 103-385.5S264.833 427.667 382.5 359 628.667 256 768 256zm128 1247v-190c0-9.333-3-17.167-9-23.5s-13.333-9.5-22-9.5H673c-8.667 0-16.333 3.333-23 10s-10 14.333-10 23v190c0 8.667 3.333 16.333 10 23s14.333 10 23 10h192c8.667 0 16-3.167 22-9.5s9-14.167 9-23.5zm-2-344 18-621c0-8-3.333-14-10-18-6.667-5.333-14.667-8-24-8H658c-9.333 0-17.333 2.667-24 8-6.667 4-10 10-10 18l17 621c0 6.667 3.333 12.5 10 17.5s14.667 7.5 24 7.5h185c9.333 0 17.167-2.5 23.5-7.5s9.833-10.833 10.5-17.5z",
    fill: "#d10026",
    className: "fill-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeltaWarningIcon);
export default __webpack_public_path__ + "static/media/delta-warning-icon.a03d7ccd4cc50410eb6e53869444f1f2.svg";
export { ForwardRef as ReactComponent };